module.exports = __webpack_public_path__ + "img/kf.dcdddf51.png";